import type { RootState } from "@src/store/rootState";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";

export function getVariationDraftText(state: RootState) {
  const mod = getVariationDraft(state);
  return mod?.type === "text" ? mod : undefined;
}
